<div class="min-h-screen max-h-screen min-w-screen max-w-screen bg-white overflow-hidden">
    <div class="flex items-center justify-center flex-col h-[40vh] text-center text-white"
         [style.background]="'linear-gradient(to bottom, ' + colorOne + ', ' + colorTwo + ')'">
        <img src="svg/logo-blanco.svg" class="w-[130px]" alt="Logo Fincomercio" />
        <label class="text-2xl font-bold">ACTUALIZA TUS DATOS</label>
        <label class="text-[1.3rem] font-medium mb-4 uppercase">
            Cooperativa de ahorro y crédito fincomercio ltda.
        </label>
    </div>
    <div class="bg-white h-[60vh] flex flex-col w-screen mt-0">
        <div class="flex justify-between w-auto h-6 bg-white -mt-1">
            <label class="text-white font-medium text-[10px] px-2 rounded-b-2xl"
                   [style.background]="'linear-gradient(to bottom, ' + colorOne + ', ' + colorTwo + ')'"
                   for="version">
                <b>V. {{ webVersion }}</b>
            </label>

            @if(consultor() !== null) {
                <label class="text-white font-medium text-[10px] px-2 rounded-b-2xl"
                       [style.background]="'linear-gradient(to bottom, ' + colorOne + ', ' + colorTwo + ')'"
                       for="">
                    <b>Tu asesor:</b> {{ consultor()?.name }}
                </label>
            }
        </div>
        <div class="h-full w-screen flex flex-col text-justify p-3 text-base text-gray-900 overflow-x-hidden overflow-y-auto">
        @if (consultor() !== null) {

            <label class="text-[14.1px] mb-2 text-center" for="information">
                Mantener tus datos actualizados es un deber como asociado, garantiza el acceso de forma fácil y segura a los beneficios de la Cooperativa y canales transaccionales.
            </label>

            <label class="text-[14.1px] mb-2 text-center" for="information">
                Autorización tratamiento de datos personales y habeas data autorizo de forma expresa a FINCOMERCIO y dentro de lo estipulado en la Ley 1581 de 2012 y 1266 de 2008, para que reciba, solicite, almacene, consulte, reporte, utilize y entregue la información relacionada con mis datos personales. <br>
            </label>

            <label class="text-[14.1px] mb-2 text-center" for="information">
                Durante el proceso de actualización validaremos tu identidad. Recibirás mensajes en tu celular, por esto debes tenerlo a mano, al igual que el documento de identificación.<br>
            </label>

            <label class="text-[14.1px] mb-2 text-center" for="information">
                Si estas listo para iniciar, presiona el botón "Iniciar" a continuación.
            </label>

            <div class="h-10 w-full flex items-center justify-center">
                <button type="button" class="btn-primary" (click)="next()">
                    Iniciar
                </button>
            </div>
        }@else {
            <div class="flex flex-col justify-center items-center w-full h-auto space-y-2">

                <label class="text-base font-sans mb-2 text-center" for="information">
                    Por favor solicita a tu Asesor Comercial el link o su QR para poder
                    continuar con tu proceso de actualización
                </label>

                <div class="">
                    <label for="text-base font-sans mb-2 text-center">
                        Volver a
                    </label>
                    <a href="https://www.fincomercio.com" class="text-blue-700 font-bold mb-2 text-center" target="_blank" rel="noopener noreferrer">
                        Fincomercio
                    </a>
                </div>
            </div>
            }
        </div>
    </div>
</div>
